<template>
  <div class="terms">
    <h1>{{ $t('menu_terms_policy') }}</h1>
    <div class="terms-content">
      <p>{{ $t('terms_policy.description') }}</p>

      <p><strong>{{ $t('terms_policy.section_1_title') }}</strong><br>
        {{ $t('terms_policy.section_1_text') }}<br><br></p>

      <p><strong>{{ $t('terms_policy.section_2_title') }}</strong><br>
        {{ $t('terms_policy.section_2_text_1') }}<br>
        {{ $t('terms_policy.section_2_text_2') }}<br>
        {{ $t('terms_policy.section_2_text_3') }}<br><br></p>

      <p><strong>{{ $t('terms_policy.section_3_title') }}</strong><br>
        {{ $t('terms_policy.section_3_text') }}<br><br></p>

      <p><strong>{{ $t('terms_policy.section_4_title') }}</strong><br>
        {{ $t('terms_policy.section_4_text_1') }}<br>
        {{ $t('terms_policy.section_4_text_2') }}<br>
        {{ $t('terms_policy.section_4_text_3') }}<br>
        {{ $t('terms_policy.section_4_text_4') }}<br>
        {{ $t('terms_policy.section_4_text_5') }}<br>
        
        <br></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsView',
  data() {
    return {
      login_error: ""
    };
  },
  methods: {
    get_start() {
      this.$router.push({ name: "terms" });
    }
  }
}
</script>

<style scoped>
.terms {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: left;
  font-family: 'Roboto', sans-serif;
}

.terms h1 {
  margin-bottom: 25px;
}

.terms-content {
  background: linear-gradient(135deg, #f0f0f0, #ffffff);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  line-height: 1.8;
  font-size: 16px;
  color: #333;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.terms-content p {
  margin-bottom: 20px;
}

.terms-content strong {
  color: #eb9a85;
}

.terms-content ul, .terms-content ol {
  margin-left: 20px;
  margin-bottom: 15px;
}

.terms-content li {
  margin-bottom: 10px;
}
</style>
